import './Footer.css';

const Footer = () => {
  return <div className="footer">© 2024 NXDEC</div>;
};

export default Footer;
